import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import cn from "classnames";
import Slider from "react-slick";
import styles from "./History.module.sass";
import { useArticles } from "../../../../hooks/useArticles";
import { getPocketBaseFileUrl, getCategoryColor } from "../../../../utils/formatters";

const History = () => {
    const [carouselArticles, setCarouselArticles] = useState([]);
    const [loading, setLoading] = useState(true);
    const { fetchArticles } = useArticles();

    // Charger les articles du carrousel au montage du composant
    useEffect(() => {
        loadCarouselArticles();
    }, []);

    const loadCarouselArticles = async () => {
        try {
            setLoading(true);
            
            // Récupérer tous les articles avec carrousel = true
            const result = await fetchArticles({
                filter: 'carrousel = true',
                sort: '-created',
                expand: 'category'
            });
            
            console.log('Articles carrousel récupérés:', result.items);
            setCarouselArticles(result.items);
        } catch (error) {
            console.error('Erreur lors du chargement des articles carrousel:', error);
        } finally {
            setLoading(false);
        }
    };

    // Formater les articles pour le carrousel
    const formatArticleForCarousel = (article) => {
        return {
            url: `/article/${article.id}`,
            title: article.title,
            content: article.excerpt || "Découvrez cet article passionnant...",
            image: `url('${getPocketBaseFileUrl(article, article.cover_image)}')`,
            status: getCategoryColor(article.expand?.category?.name),
            statusContent: article.expand?.category?.name || "Article",
        };
    };
    const settings = {
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        adaptiveHeight: true,
    };

    // Afficher un loader pendant le chargement
    if (loading) {
        return (
            <div className={styles.history}>
                <div className={styles.wrap}>
                    <div style={{ textAlign: 'center', padding: '40px' }}>
                        Chargement du carrousel...
                    </div>
                </div>
            </div>
        );
    }

    // Si aucun article carrousel, ne rien afficher
    if (carouselArticles.length === 0) {
        return null;
    }

    // Formater les articles pour le slider
    const formattedArticles = carouselArticles.map(formatArticleForCarousel);

    return (
        <div className={styles.history}>
            <div className={styles.wrap}>
                <Slider className="history-slider" {...settings}>
                    {formattedArticles.map((x, index) => (
                        <div className={styles.slide} key={index}>
                            <div className={cn("history-item", styles.item)}>
                                <div
                                    className={styles.preview}
                                    style={{ backgroundImage: x.image }}
                                ></div>
                                <div className={styles.details}>
                                    <div
                                        className={cn(
                                            `status-${x.status}`,
                                            styles.status
                                        )}
                                    >
                                        {x.statusContent}
                                    </div>
                                    <div className={styles.title}>
                                        {x.title}
                                    </div>
                                    <div className={styles.content}>
                                        {x.content}
                                    </div>
                                    <Link
                                        to={x.url}
                                        className={cn(
                                            "button-small",
                                            styles.button
                                        )}
                                    >
                                        Lire l'article
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    );
};

export default History;
